<template>
  <div class="wrapper">
    <div class="global_express_popup_wrap">
      <div class="global_express_popup_container row">
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
        <div class="position-relative form-group col-12">
          <label for="exampleText" class="">Token</label>
          <textarea class="form-control" @change.stop.prevent="store.commit('integration.api.access_token', $event.target.value)"></textarea>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 p-0">Calculation file</label>
          <div class="upload-file">
            <label for="upload-file" class="btn btn-outline-success cursor-pointer mb-0">From file</label>
            <input id="upload-file" type="file" @input="changeExcelFile" />
          </div>
          <p class="mb-0">
            <small>
              File used to calculate orders
              <strong>
                <span v-if="integration.api.file">: {{ integration.api.file.name }}</span>
              </strong>
            </small>
          </p>
          <p class="mb-0">
            <small>
              <span> If you do not have a sample, please download </span>
              <a @click.prevent="clickDownloadTemplate" href="#">it here</a>
              <span> or the </span>
              <a @click.prevent="clickDownloadLatestCalculationFile" href="#">latest calculation file</a>.
            </small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import { utils, writeFileXLSX } from 'xlsx'

export default {
  mixins: [Event],
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    submitUri() {
      return `carrier-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    integration() {
      return _.mergeLeft(
        {
          api: {
            token: ''
          }
        },
        this.data.integration || {}
      )
    }
  },
  mounted() {
    this.$emitter.on('Modal.CarrierAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.CarrierAccount.Edit.Submit', this.submit)
  },
  methods: {
    changeExcelFile(e) {
      let file = e.target.files[0]
      this.store.commit('integration.api.file', file)
    },
    clickDownloadTemplate() {
      let workbook = utils.book_new()
      let calculateData = [
        ['Total Weight', { t: 'n', v: 3, f: 'SUM(I3:I53)' }, 'Total Price', { t: 'n', v: 3, f: 'SUM(J3:J53)' }],
        ['SKU', 'Quantity', 'Description', 'Weight', 'Width', 'Height', 'Length', 'Price', 'Sub-Weight', 'Sub-Price']
      ]
      for (let i = 3; i < 53; i++) {
        calculateData.push([
          '', // SKU List
          '', // Quantity
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,2,FALSE),"")` }, //Description
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,3,FALSE),"")` }, //Weight
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,4,FALSE),"")` }, //Width
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,5,FALSE),"")` }, //Height
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,6,FALSE),"")` }, //Length
          { t: 'n', v: 3, f: `IFERROR(VLOOKUP($A${i},Data!$A$2:$I$1000,7,FALSE)*B${i},"")` }, //Price
          { t: 'n', v: 3, f: `IFERROR(B${i}*D${i},"")` }, //Sub-Weight
          { t: 'n', v: 3, f: `IFERROR(B${i}*H${i},"")` } //Sub-Price
        ])
      }

      utils.book_append_sheet(workbook, utils.aoa_to_sheet(calculateData), 'Calculate')
      utils.book_append_sheet(workbook, utils.aoa_to_sheet([['SKU List', 'Description', 'Weight', 'Width', 'Height', 'Length', 'Price']]), 'Data')

      writeFileXLSX(workbook, `Calculate-${this.data.name}.xlsx`)
    },
    clickDownloadLatestCalculationFile() {
      this.$emitter.emit('Modal.CarrierAccount.Edit.DownloadLatestCalculationFile')
    },
    submit(data) {
      this.submitForm(
        data,
        {
          done: () => {
            this.$emitter.emit('TableList.Refresh')
            this.$emit('close')
          }
        },
        {
          contentType: 'params'
        }
      )
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
body.page-carrier-account {
  .upload-file #upload-file {
    display: none;
  }
}
</style>
